"use client"
import {Link} from "react-router-dom";
import { encryptId } from "../../utils/crypto";

export default function ProjectCard({ project, removeProject, openCompleteProjectModal}) {
  const getStatusStyle = (status) => {
    switch (status) {
      case 'assigned': return { bg: 'rgba(59, 130, 246, 0.1)', color: '#60a5fa', border: 'rgba(59, 130, 246, 0.2)' };
      case 'unassigned': return { bg: 'rgba(245, 158, 11, 0.1)', color: '#fbbf24', border: 'rgba(245, 158, 11, 0.2)' };
      case 'completed': return { bg: 'rgba(16, 185, 129, 0.1)', color: '#34d399', border: 'rgba(16, 185, 129, 0.2)' };
      default: return { bg: 'rgba(156, 163, 175, 0.1)', color: '#9ca3af', border: 'rgba(156, 163, 175, 0.2)' };
    }
  };
  const statusStyle = getStatusStyle(project.status);

  return (
    <div style={{
      background: 'var(--bg-card)',
      border: '1px solid var(--border-glass)',
      borderRadius: '20px',
      overflow: 'hidden',
      position: 'relative',
      transition: 'all 0.3s ease',
    }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'translateY(-4px)';
      e.currentTarget.style.borderColor = statusStyle.border;
      e.currentTarget.style.boxShadow = `0 12px 40px ${statusStyle.bg}`;
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.borderColor = 'var(--border-glass)';
      e.currentTarget.style.boxShadow = 'none';
    }}
    >
      {/* Top accent */}
      <div style={{
        height: '2px',
        background: `linear-gradient(90deg, transparent, ${statusStyle.color}, transparent)`,
        opacity: 0.5,
      }} />

      <div style={{ padding: '24px' }}>
        <Link to={`/ProjectMap/${encodeURIComponent(encryptId(project.client_project_id))}`} style={{ textDecoration: 'none' }}>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '1.1rem',
            fontWeight: 600,
            color: 'var(--text-primary)',
            marginBottom: '8px',
          }}>{project.title}</h2>
          <p style={{
            fontSize: '0.85rem',
            color: 'var(--text-secondary)',
            marginBottom: '16px',
            lineHeight: 1.6,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}>{project.description}</p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Status:</span>
              <span style={{
                padding: '3px 12px',
                borderRadius: '9999px',
                background: statusStyle.bg,
                border: `1px solid ${statusStyle.border}`,
                fontSize: '0.7rem',
                fontWeight: 600,
                color: statusStyle.color,
                textTransform: 'capitalize',
              }}>{project.status}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Pro:</span>
              <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                {project.status === 'unassigned' ? 'Unassigned' : project.professional_names}
              </span>
            </div>
          </div>

          {project.status === 'completed' && (
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                {[...Array(5)].map((_, i) => (
                  <span key={i} style={{ color: i < project.rating ? '#fbbf24' : 'var(--border-glass)', fontSize: '0.9rem' }}>★</span>
                ))}
              </div>
              {project.comment && (
                <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>"{project.comment}"</p>
              )}
            </div>
          )}
        </Link>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', paddingTop: '12px', borderTop: '1px solid var(--border-subtle)' }}>
          {project.status === 'assigned' && (
            <button
              onClick={() => openCompleteProjectModal(project.client_project_id)}
              style={{
                padding: '8px 20px',
                borderRadius: '10px',
                border: 'none',
                background: 'linear-gradient(135deg, #10b981, #059669)',
                color: '#fff',
                fontSize: '0.8rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(16, 185, 129, 0.3)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              Complete
            </button>
          )}
          {project.status === 'unassigned' && (
            <button
              onClick={() => removeProject(project.client_project_id)}
              style={{
                padding: '8px 20px',
                borderRadius: '10px',
                border: '1px solid rgba(248, 113, 113, 0.3)',
                background: 'rgba(248, 113, 113, 0.08)',
                color: '#f87171',
                fontSize: '0.8rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(248, 113, 113, 0.15)'; e.currentTarget.style.borderColor = 'rgba(248, 113, 113, 0.5)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(248, 113, 113, 0.08)'; e.currentTarget.style.borderColor = 'rgba(248, 113, 113, 0.3)'; }}
            >
              Remove
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

